import { render, staticRenderFns } from "./FullPageWidth.vue?vue&type=template&id=39f9e204&scoped=true&"
import script from "./FullPageWidth.vue?vue&type=script&lang=js&"
export * from "./FullPageWidth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39f9e204",
  null
  
)

export default component.exports